import tw from 'tailwind.macro';

export const DropdownContainer = tw.div`
absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white shadow-xs
`;

export const UserInfoContainer = tw.div`
px-4 py-6
`;

export const NavLinkContainer = tw.div`
py-1
`;

export const UseInfo = tw.span`
text-gray-900 text-lg
`;

export const Border = tw.div`
border-t border-gray-200
`;
